import './Card_Compability.css';
import React, { useState, useMemo, useEffect } from 'react';
import compatibilidades from '../../helpers/compatibilidades.js';
import { signos, signoEsToEn } from '../../common/constants/signos.js';
import { useAppDispatch, useAppSelector } from '../../infrastructure/redux/hooks.ts';
import { fetchCompatibility } from '../../application/usecases/fetchCompatibility.ts';

const normalize = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const CardCompability = () => {
  const [signo1, setSigno1] = useState('');
  const [signo2, setSigno2] = useState('');
  const dispatch = useAppDispatch();
  const { data: apiData, loading } = useAppSelector((state) => state.compatibility);

  const normalizado = useMemo(() => {
    const dict = {};
    for (const key of Object.keys(compatibilidades)) {
      const normalizedKey = normalize(key);
      dict[normalizedKey] = {};
      for (const innerKey of Object.keys(compatibilidades[key])) {
        dict[normalizedKey][normalize(innerKey)] = compatibilidades[key][innerKey];
      }
    }
    return dict;
  }, []);

  const compat = useMemo(() => {
    if (!signo1 || !signo2) return null;

    const s1 = normalize(signo1);
    const s2 = normalize(signo2);

    const data = normalizado[s1]?.[s2] || normalizado[s2]?.[s1];
    if (!data) return null;

    const { amor, comunicacion, sexualidad, objetivos, ritmo } = data;
    const general = Math.round((amor + comunicacion + sexualidad + objetivos + ritmo) / 5);

    return { ...data, general };
  }, [signo1, signo2, normalizado]);

  useEffect(() => {
    if (!signo1 || !signo2) return;

    const en1 = signoEsToEn[signo1];
    const en2 = signoEsToEn[signo2];

    if (en1 && en2) {
      dispatch(fetchCompatibility({ sign1: en1, sign2: en2 }));
    }
  }, [signo1, signo2, dispatch]);

  return (
    <div className="compatibilidad-container">
      <div className="compatibilidad-titulos">
        <h1>Compatibilidad de signos</h1>
        <h2>Selecciona dos signos</h2>
      </div>

      <div className="select-container">
        <select
          className="select-signo"
          value={signo1}
          onChange={(e) => setSigno1(e.target.value)}
        >
          <option value="">Primer signo</option>
          {signos.map((s) => (
            <option key={s.name} value={s.name}>{s.name}</option>
          ))}
        </select>

        <select
          className="select-signo"
          value={signo2}
          onChange={(e) => setSigno2(e.target.value)}
        >
          <option value="">Segundo signo</option>
          {signos.map((s) => (
            <option key={s.name} value={s.name}>{s.name}</option>
          ))}
        </select>
      </div>

      {compat && (
        <div className="compatibilidad-resultados">
          <div className="signos-header">
            <div className="signo-avatar">
              <img src={signos.find(s => s.name === signo1)?.img} alt={signo1} />
              <span>{signo1}</span>
            </div>
            <span className="signos-separator">&</span>
            <div className="signo-avatar">
              <img src={signos.find(s => s.name === signo2)?.img} alt={signo2} />
              <span>{signo2}</span>
            </div>
          </div>

          <div className="porcentajes-grid">
            <div className="porcentaje-item">
              <span className="porcentaje-label">General</span>
              <span className="porcentaje-valor">{compat.general}%</span>
            </div>
            <div className="porcentaje-item">
              <span className="porcentaje-label">Amor</span>
              <span className="porcentaje-valor">{compat.amor}%</span>
            </div>
            <div className="porcentaje-item">
              <span className="porcentaje-label">Comunicación</span>
              <span className="porcentaje-valor">{compat.comunicacion}%</span>
            </div>
            <div className="porcentaje-item">
              <span className="porcentaje-label">Sexualidad</span>
              <span className="porcentaje-valor">{compat.sexualidad}%</span>
            </div>
            <div className="porcentaje-item">
              <span className="porcentaje-label">Objetivos</span>
              <span className="porcentaje-valor">{compat.objetivos}%</span>
            </div>
            <div className="porcentaje-item">
              <span className="porcentaje-label">Ritmo</span>
              <span className="porcentaje-valor">{compat.ritmo}%</span>
            </div>
          </div>

          {loading && <p className="api-loading">Cargando descripción detallada...</p>}

          {apiData && !loading && (
            <div className="compatibilidad-detalle">
              {apiData.amor && (
                <div className="detalle-section">
                  <h3 className="detalle-subtitulo">Compatibilidad en el Amor</h3>
                  <p className="detalle-texto">{apiData.amor}</p>
                </div>
              )}
              {apiData.comunicacion && (
                <div className="detalle-section">
                  <h3 className="detalle-subtitulo">Compatibilidad en la Comunicación</h3>
                  <p className="detalle-texto">{apiData.comunicacion}</p>
                </div>
              )}
              {apiData.sexualidad && (
                <div className="detalle-section">
                  <h3 className="detalle-subtitulo">Compatibilidad en la Sexualidad</h3>
                  <p className="detalle-texto">{apiData.sexualidad}</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CardCompability;
